(function () {
  'use strict';

  window.__c27Support = window.__c27Support || {};

  var NS = 'ticket';
  var bootKey = NS + 'Bootstrapped';
  var controllers = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var fallbackMap = new Map();

  function controllerMap() {
    return controllers || fallbackMap;
  }

  function collectRoots(container) {
    if (!container) return [];
    var roots = [];
    if (container.matches && container.matches('[data-c27-support-component]')) {
      roots.push(container);
    }
    roots.push.apply(
      roots,
      Array.prototype.slice.call(
        container.querySelectorAll('[data-c27-support-component]')
      )
    );
    return roots;
  }

  function formatBytes(bytes) {
    if (bytes <= 0) return '0 B';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(bytes < 10 * 1024 ? 1 : 0) + ' KB';
    }
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function createTicketFormController(root) {
    var maxBytes = parseInt(root.getAttribute('data-max-attachment-bytes') || '15728640', 10);
    var pendingMessage = root.getAttribute('data-pending-message') || 'Ticket submission will be available soon.';
    var errors = {
      device: root.getAttribute('data-error-device') || 'Please choose a device.',
      category: root.getAttribute('data-error-category') || 'Please choose a category.',
      description: root.getAttribute('data-error-description') || 'Please describe your issue.',
      attachments: root.getAttribute('data-error-attachments') || 'Total attachment size must be 15 MB or less.',
    };

    var deviceField = root.querySelector('[data-c27-support-ticket-field="device"]');
    var categoryField = root.querySelector('[data-c27-support-ticket-field="category"]');
    var descriptionField = root.querySelector('[data-c27-support-ticket-field="description"]');
    var fileInput = root.querySelector('[data-c27-support-ticket-file-input]');
    var dropzone = root.querySelector('[data-c27-support-ticket-dropzone]');
    var attachmentList = root.querySelector('[data-c27-support-ticket-attachment-list]');
    var progressFill = root.querySelector('[data-c27-support-ticket-progress-fill]');
    var usageLabel = root.querySelector('[data-c27-support-ticket-usage]');
    var toast = root.querySelector('[data-c27-support-ticket-toast]');
    var files = [];
    var onSubmit = null;
    var onDropzoneClick = null;
    var onFileChange = null;
    var onDragOver = null;
    var onDrop = null;

    function totalBytes() {
      return files.reduce(function (sum, file) {
        return sum + file.size;
      }, 0);
    }

    function updateUsageUI() {
      var used = totalBytes();
      var percent = Math.min(100, (used / maxBytes) * 100);
      if (progressFill) progressFill.style.width = percent + '%';
      if (usageLabel) {
        usageLabel.textContent = formatBytes(used) + ' of ' + formatBytes(maxBytes) + ' used';
      }
    }

    function showFieldError(field, message) {
      var errorEl = root.querySelector('[data-c27-support-ticket-error="' + field + '"]');
      var input =
        field === 'attachments'
          ? dropzone
          : root.querySelector('[data-c27-support-ticket-field="' + field + '"]');
      if (errorEl) {
        errorEl.textContent = message || '';
        errorEl.hidden = !message;
      }
      if (input) input.classList.toggle('is-error', Boolean(message));
    }

    function clearErrors() {
      ['device', 'category', 'description', 'attachments'].forEach(function (field) {
        showFieldError(field, '');
      });
    }

    function validate() {
      clearErrors();
      var valid = true;

      if (!deviceField || !deviceField.value) {
        showFieldError('device', errors.device);
        valid = false;
      }
      if (!categoryField || !categoryField.value) {
        showFieldError('category', errors.category);
        valid = false;
      }
      if (!descriptionField || !descriptionField.value.trim()) {
        showFieldError('description', errors.description);
        valid = false;
      }
      if (totalBytes() > maxBytes) {
        showFieldError('attachments', errors.attachments);
        valid = false;
      }

      return valid;
    }

    function renderAttachments() {
      if (!attachmentList) return;
      attachmentList.innerHTML = '';
      files.forEach(function (file, index) {
        var item = document.createElement('li');
        item.className = 'c27-support-ticket-form__attachment-item';

        var name = document.createElement('span');
        name.className = 'c27-support-ticket-form__attachment-name';
        name.textContent = file.name + ' (' + formatBytes(file.size) + ')';

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'c27-support-ticket-form__attachment-remove';
        removeBtn.setAttribute('aria-label', 'Remove ' + file.name);
        removeBtn.textContent = 'Remove';
        removeBtn.addEventListener('click', function () {
          files.splice(index, 1);
          renderAttachments();
          updateUsageUI();
          showFieldError('attachments', totalBytes() > maxBytes ? errors.attachments : '');
        });

        item.appendChild(name);
        item.appendChild(removeBtn);
        attachmentList.appendChild(item);
      });
      updateUsageUI();
    }

    function addFiles(fileList) {
      if (!fileList || !fileList.length) return;
      files = files.concat(Array.prototype.slice.call(fileList));
      renderAttachments();
      if (totalBytes() > maxBytes) {
        showFieldError('attachments', errors.attachments);
      } else {
        showFieldError('attachments', '');
      }
    }

    return {
      init: function () {
        updateUsageUI();

        onSubmit = function (event) {
          event.preventDefault();
          if (!validate()) return;
          if (toast) {
            toast.textContent = pendingMessage;
            toast.hidden = false;
          }
        };
        root.addEventListener('submit', onSubmit);

        if (dropzone && fileInput) {
          onDropzoneClick = function () {
            fileInput.click();
          };
          onFileChange = function () {
            addFiles(fileInput.files);
            fileInput.value = '';
          };
          onDragOver = function (event) {
            event.preventDefault();
          };
          onDrop = function (event) {
            event.preventDefault();
            addFiles(event.dataTransfer.files);
          };

          dropzone.addEventListener('click', onDropzoneClick);
          fileInput.addEventListener('change', onFileChange);
          dropzone.addEventListener('dragover', onDragOver);
          dropzone.addEventListener('drop', onDrop);
        }

        [deviceField, categoryField, descriptionField].forEach(function (field) {
          if (!field) return;
          field.addEventListener('change', function () {
            var name = field.getAttribute('data-c27-support-ticket-field');
            if (name) showFieldError(name, '');
          });
          field.addEventListener('input', function () {
            var name = field.getAttribute('data-c27-support-ticket-field');
            if (name) showFieldError(name, '');
          });
        });
      },
      destroy: function () {
        if (onSubmit) root.removeEventListener('submit', onSubmit);
        if (dropzone && onDropzoneClick) dropzone.removeEventListener('click', onDropzoneClick);
        if (fileInput && onFileChange) fileInput.removeEventListener('change', onFileChange);
        if (dropzone && onDragOver) dropzone.removeEventListener('dragover', onDragOver);
        if (dropzone && onDrop) dropzone.removeEventListener('drop', onDrop);
        files = [];
        if (attachmentList) attachmentList.innerHTML = '';
        if (toast) {
          toast.hidden = true;
          toast.textContent = '';
        }
        clearErrors();
        onSubmit = null;
        onDropzoneClick = null;
        onFileChange = null;
        onDragOver = null;
        onDrop = null;
      },
      getComponent: function () {
        return 'ticket-form';
      },
    };
  }

  function createController(root) {
    var component = root.getAttribute('data-c27-support-component') || '';
    if (component === 'ticket-form') {
      return createTicketFormController(root);
    }
    return {
      init: function () {},
      destroy: function () {},
      getComponent: function () {
        return component;
      },
    };
  }

  function initRoot(root) {
    if (!root || root.dataset.c27SupportInit === 'true') return;
    var ctrl = createController(root);
    controllerMap().set(root, ctrl);
    root.dataset.c27SupportInit = 'true';
    ctrl.init();
  }

  function destroyRoot(root) {
    if (!root) return;
    var ctrl = controllerMap().get(root);
    if (!ctrl) return;
    ctrl.destroy();
    controllerMap().delete(root);
    delete root.dataset.c27SupportInit;
  }

  function scan(container) {
    collectRoots(container).forEach(initRoot);
  }

  function destroy(container) {
    collectRoots(container).forEach(destroyRoot);
  }

  function onSectionLoad(event) {
    scan(event.target);
  }

  function onSectionUnload(event) {
    destroy(event.target);
  }

  window.__c27Support[NS] = window.__c27Support[NS] || {};
  window.__c27Support[NS].scan = scan;
  window.__c27Support[NS].destroy = destroy;
  window.__c27Support[NS].collectRoots = collectRoots;

  if (!window.__c27Support[bootKey]) {
    window.__c27Support[bootKey] = true;
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
      if (window.__c27Support.routeFade && window.__c27Support.routeFade.finish) {
        window.__c27Support.routeFade.finish();
      }
    });
  } else {
    scan(document);
    if (window.__c27Support.routeFade && window.__c27Support.routeFade.finish) {
      window.__c27Support.routeFade.finish();
    }
  }
})();
